jQuery(function($) {
  var name = document.domain+".show",
      cookie_not_set = ($.cookie(name)=='' || !$.cookie(name)  || typeof $.cookie(name) === 'undefined'),
      session_not_set = ($.session.get(name) === '' || !$.session.get(name)  || typeof $.session.get(name) === 'undefined' || $.session.get(name) == 'undefined'),
      showDialog = cookie_not_set && session_not_set;

  function showNewsletter() {
    setTimeout( function(){ 
	    $.magnificPopup.open({
          'items': {
            src: '#ajaxNewsletterForm', 
            type:'inline', 
            modal:'true'
          },
          'callbacks': {
            'afterClose': function() {
              $.session.set(name, 1);
              $.cookie(name, 1, { path: '/',expires: 180 });//don't ever show
            }
          }
        });
    },6000); 
  }    

  $(document).ready(function() {
    if (showDialog) {
     showNewsletter();
    }

    $('.search-link').click(function(e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      $('.site-search').toggleClass('open'); 
      if ($('.site-search').hasClass('open')) {
        $('.site-search input[type=search]').trigger('focus');
      }
    });
    $('.open-popup-link').magnificPopup({
      type:'inline',
      alignTop: true,
      midClick: true // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
    });
    $('.newsletter-link').magnificPopup({
      type:'inline',
      alignTop: true,
      midClick: true // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
    });
    $('.mobile-nav__has-sublist > a').click(function(e) {
      e.preventDefault();
      var link = $(this),
          button = $(this).next('.mobile-nav__toggle').find("button:visible");
      button.trigger('click');
      return false;
    });
    
    $('.site-search .search-bar').submit(function(e) {
	  var searchbox = $(this).find('input[name=q]')
          search_val = searchbox.val();
      
      if ($.trim(search_val) === '') {
        searchbox.trigger('focus');
        return false;
      }
      
      return true;
        
    });

    $('select.browse-by-dropdown')
      .bind('change', function() {
        var page = jQuery(this).val();
        location.href = page;
      });

    $('select.fancy-design').each(function() {
      var text = $(this).hasClass('sort-option') ? 'Sort By '+ $(this).find('option:selected').text() : $(this).attr('data-label');
      $(this).parent().show();
      $(this).selectBoxIt({
        theme: 'bootstrap',
        showEffect: 'fadeIn',
        showEffectSpeed: 200,
        hideEffect: 'fadeOut',
        hideEffectSpeed: 200,
        downArrowIcon: 'glyphicon glyphicon-chevron-down',
        defaultText: text,
        autoWidth: $(this).hasClass('sort-option')
      });
    });

    $('select.browse-by-dropdown').each(function() {
      var text = 'Browse By: '+ $(this).find('option:selected').text();
      $(this).selectBoxIt({
        theme: 'bootstrap',
        showEffect: 'fadeIn',
        showEffectSpeed: 200,
        hideEffect: 'fadeOut',
        hideEffectSpeed: 200,
        downArrowIcon: 'glyphicon glyphicon-chevron-down',
        defaultText: text,
        autoWidth: true
      });
    });
  });
});